import { render, staticRenderFns } from "./LoginTitle.vue?vue&type=template&id=31e5fef6&scoped=true"
import script from "./LoginTitle.vue?vue&type=script&lang=ts"
export * from "./LoginTitle.vue?vue&type=script&lang=ts"
import style0 from "./LoginTitle.vue?vue&type=style&index=0&id=31e5fef6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5fef6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e5fef6')) {
      api.createRecord('31e5fef6', component.options)
    } else {
      api.reload('31e5fef6', component.options)
    }
    module.hot.accept("./LoginTitle.vue?vue&type=template&id=31e5fef6&scoped=true", function () {
      api.rerender('31e5fef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/LoginTitle.vue"
export default component.exports